<template>
  <div :style="divStyle">
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <p>当前正在进行第 {{ current + 1 }} 步</p>
    <Steps :current="current">
      <Step title="步骤-1" content="选择操作设备"></Step>
      <Step title="步骤-2" content="查看设备"></Step>
      <Step title="步骤-3" content="批量下发阶梯气价"></Step>
    </Steps>
    <div
      style="width:30%; left:30%; position:relative; margin-top:15px;"
      v-show="step[0]"
    >
      <Form
        ref="formSearch"
        :label-width="120"
        :model="formSearch"
        :rules="formSearchRule"
      >
        <FormItem label="选择用气类型：" prop="gasType">
          <Select
            :transfer="true"
            v-model="formSearch.gasType"
            :label-in-value="true"
          >
            <Option
              v-for="(value, key) in gasTypeList"
              :value="key"
              :key="key"
              >{{ value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="批量筛选方式：" prop="selectCondition">
          <Select v-model="formSearch.selectCondition">
            <Option value="batch">按批次</Option>
            <Option value="address">按地址</Option>
          </Select>
        </FormItem>
        <FormItem
          label="输入或选择条件："
          prop="condition"
          @on-change="onSelectChange"
        >
          <div v-if="formSearch.selectCondition == 'batch'">
            <Row type="flex" justify="center" align="bottom" :gutter="16">
              <Col span="8" style="text-align: right;">
                生产批次
              </Col>
              <Col span="16">
                <Tooltip disabled>
                  <Input
                    v-model="formSearch.produceBatch"
                    placeholder="请输入6位生产批次号"
                  ></Input>
                </Tooltip>
              </Col>
            </Row>
            <Row type="flex" justify="center" align="bottom" :gutter="16">
              <Col span="8" style="text-align: right;">
                序号
              </Col>
              <Col span="16">
                <Tooltip
                  max-width="200"
                  content="例:输入1-28,55,60-99  代表筛选1到28,55,60到99的数据"
                >
                  <Input
                    v-model="formSearch.produceIndex"
                    placeholder="请输入生产序号"
                  ></Input>
                </Tooltip>
              </Col>
            </Row>
          </div>
          <Cascader
            :data="addressData"
            change-on-select
            filterable
            transfer
            @on-change="chooseAddress"
            v-if="formSearch.selectCondition == 'address'"
          ></Cascader>
        </FormItem>
      </Form>
    </div>
    <div v-if="step[1]">
      <p>将下发如下共{{ dataCount }}个设备</p>
      <Table
        ref="selectionTable"
        :max-height="height"
        :data="showData"
        :columns="showColumns"
        stripe
        border
      ></Table>
      <Page
        :current="currentPage"
        :total="dataCount"
        :page-size="pageSize"
        show-sizer
        show-total
        @on-change="changePage"
        @on-page-size-change="changePageSize"
        style="text-align:right"
      ></Page>
    </div>
    <div v-if="step[2]">
      <Tabs ref="tabs">
        <TabPane label="下发阶梯气价">
          <Table
            ref="selectionLadderTable"
            :max-height="height"
            :data="showLadderData"
            :columns="showLadderColumns"
            stripe
            border
            highlight-row
            @on-current-change="onSelectionLadderTableChange"
          ></Table>
          <Page
            :current="currentLadderPage"
            :total="dataLadderCount"
            :page-size="pageLadderSize"
            show-sizer
            show-total
            @on-change="changeLadderPage"
            @on-page-size-change="changePageLadderSize"
            style="text-align:right"
          ></Page>
        </TabPane>
      </Tabs>
    </div>
    <div v-if="isButtonShow">
      <Button class="button" type="primary" @click="pre">上一步</Button>
      <Button class="button" type="primary" @click="next">下一步</Button>
    </div>
    <div v-if="!isButtonShow">
      <Button class="button" @click="showResult = true" type="primary"
        >查看结果</Button
      >
      <Button class="button" @click="reflash" type="primary">返回</Button>
    </div>
    <Drawer
      width="340"
      title="指令下发结果"
      :closable="false"
      v-model="showResult"
    >
      <p v-for="(value, key) in array" :key="key" :value="value">
        <span>
          {{ value.id + " " }}
          <span v-if="value.state == '等待下发'" style="color:blue">{{
            value.state
          }}</span>
          <span v-if="value.state == '下发成功'" style="color:green">{{
            value.state
          }}</span>
          <span
            v-if="value.state != '下发成功' && value.state != '等待下发'"
            style="color:red"
            >{{ value.state }}</span
          >
        </span>
        <Icon
          color="blue"
          type="ios-loading"
          v-if="value.state == '等待下发'"
          size="18"
          class="demo-spin-icon-load"
          style="margin-left:10px"
        ></Icon>
        <Icon
          color="green"
          type="ios-checkmark-circle-outline"
          v-if="value.state == '下发成功'"
          size="18"
          style="margin-left:10px"
        ></Icon>
        <Icon
          color="red"
          type="ios-close-circle-outline"
          v-if="value.state != '下发成功' && value.state != '等待下发'"
          size="18"
          style="margin-left:10px"
        ></Icon>
      </p>
    </Drawer>
  </div>
</template>

<script>
export default {
  name: "instructions_ladder_for_list",
  computed: {
    divStyle() {
      var style = {};
      if (this.$parent.$refs.mainContent) {
        style.width = this.$parent.$refs.mainContent.clientWidth - 54 + "px";
      } else {
        style.width = window.innerWidth - 279 + "px";
      }
      //style.height = (this.$parent.$refs.mainContent.clientHeight - 54) + 'px';
      return style;
    },
  },
  mounted() {
    this.request();
  },
  data() {
    const validateCondition = (rule, value, callback) => {
      if (this.formSearch.selectCondition == "batch") {
        let reg = /^\d{6}$/;
        if (
          !this.formSearch.produceBatch ||
          !reg.test(this.formSearch.produceBatch)
        ) {
          callback(new Error("请输入6位生产批次号..."));
        } else if (!this.formSearch.produceIndex) {
          callback(new Error("请输入生产序号..."));
        } else {
          this.formSearch.produceIndex = this.formSearch.produceIndex.replace(
            /，/g,
            ","
          );
          let indexArr = this.formSearch.produceIndex.split(",");
          for (let i = 0; i < indexArr.length; i++) {
            if (!indexArr[i]) {
              callback(new Error("请输入正确的格式..."));
            }
            if (isNaN(indexArr[i] * 1)) {
              let param = indexArr[i].split("-");
              if (param.length != 2) {
                callback(new Error("请输入正确的格式..."));
              } else {
                if (
                  !param[0] ||
                  !param[1] ||
                  isNaN(param[0] * 1) ||
                  isNaN(param[1] * 1) ||
                  param[0] * 1 <= 0 ||
                  (param[0] * 1) % 1 !== 0 ||
                  param[1] * 1 <= 0 ||
                  (param[1] * 1) % 1 !== 0 ||
                  param[0] * 1 >= param[1] * 1
                ) {
                  callback(new Error("请输入正整数..."));
                }
              }
            } else if (indexArr[i] * 1 <= 0 || (indexArr[i] * 1) % 1 !== 0) {
              callback(new Error("请输入正整数..."));
            }
          }
        }
        callback();
      } else if (this.formSearch.selectCondition == "address") {
        if (!this.formSearch.addressDataSelect) {
          callback(new Error("请选择地址..."));
        } else {
          callback();
        }
      } else {
        callback(new Error("请选择筛选方式..."));
      }
    };
    return {
      current: 0,
      isSpinShow: false,
      step: [true, false, false],
      height: window.innerHeight,
      formSearch: {
        gasType: null,
        selectCondition: "batch",
        produceBatch: null,
        produceIndex: null,
        addressDataSelect: null,
      },
      formSearchRule: {
        gasType: [
          {
            required: true,
            message: "请选择用气类型",
            trigger: "change",
          },
        ],
        condition: [
          {
            required: true,
            validator: validateCondition,
          },
        ],
      },
      addressData: [],
      searchParam: {
        gasType: null,
        selectCondition: "batch",
        meterList: [],
        addressId: null,
      },
      currentLadderPage: 1,
      dataLadderCount: 0,
      pageLadderSize: 10,
      showLadderData: [],
      showLadderColumns: [
        {
          title: "阶梯气价id",
          key: "ladderPriceId",
          width: 100,
        },
        {
          title: "阶梯气价名称",
          key: "ladderPriceName",
        },
        {
          title: "用气类型",
          key: "gasTypeName",
        },
        {
          title: "管辖机构",
          key: "governingBodyName",
        },
        {
          title: "主阶梯气价",
          key: "mainPlan",
          tooltip: true,
        },
        {
          title: "备用阶梯气价",
          key: "standbyPlan",
          tooltip: true,
        },
      ],
      selectedRow: null,
      currentPage: 1,
      dataCount: 0,
      pageSize: 10,
      showData: [],
      showColumns: [
        {
          title: "设备编号",
          key: "meterId",
        },
        {
          width: 400,
          title: "设备地址",
          key: "addressLowestLevelAddressIds",
        },
        {
          title: "用户姓名",
          key: "customerName",
        },
        {
          title: "设备类型",
          key: "meterTypeName",
        },
      ],
      meterIds: "",
      gasTypeList: global.gasType,
      array: [],
      showResult: false,
      isButtonShow: true,
    };
  },
  methods: {
    onSelectChange() {
      this.$refs["formSearch"].validate((valid) => {});
    },
    reflash() {
      this.$parent.reloadPage();
    },
    chooseAddress(data) {
      if (data.length > 0) {
        this.formSearch.addressDataSelect = data[data.length - 1] * 1;
      } else {
        this.formSearch.addressDataSelect = null;
      }
    },
    showPage() {
      let that = this;
      that.isSpinShow = true;
      $.ajax({
        url:
          "/api/instructionsForList/selectList?page=" +
          that.currentPage +
          "&pageAmount=" +
          that.pageSize,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(that.searchParam),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo,
            });
            return;
          }
          that.showData = data.body.pager.resultList;
          that.dataCount = data.body.pager.amount;
          that.meterIds = data.body.meterIds;
          if (that.meterIds) {
            let meterList = {};
            that.meterIds.split(",").map((item) => {
              let param = {
                id: item,
                state: "等待下发",
              };
              meterList[item] = param;
            });
            that.array = meterList;
          }
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常",
          });
        },
        complete: function() {
          that.isSpinShow = false;
        },
      });
    },
    changePage(index) {
      this.currentPage = index;
      this.showPage();
    },
    changePageSize(size) {
      this.pageSize = size;
      this.showPage();
    },
    pre() {
      var that = this;
      if (that.current == 1) {
        that.current = 0;
        that.step[1] = false;
        that.step[0] = true;
      } else if (that.current == 2) {
        that.current = 1;
        that.step[2] = false;
        that.step[1] = true;
      }
    },
    next() {
      var that = this;
      if (that.current == 0) {
        that.$refs["formSearch"].validate((valid) => {
          if (valid) {
            let meterList = null;
            let addressId = null;
            if (that.formSearch.selectCondition == "batch") {
              let indexList = [];
              let indexArr = that.formSearch.produceIndex.split(",");
              for (let i = 0; i < indexArr.length; i++) {
                if (isNaN(indexArr[i] * 1)) {
                  let param = indexArr[i].split("-");
                  for (let j = param[0] * 1; j <= param[1] * 1; j++) {
                    if (indexList.indexOf(j) == -1) {
                      indexList.push(j);
                    }
                  }
                } else {
                  if (indexList.indexOf(indexArr[i] * 1) == -1) {
                    indexList.push(indexArr[i] * 1);
                  }
                }
              }
              meterList = indexList.map((item) => {
                let sup = "";
                while (
                  (that.formSearch.produceBatch + sup + item).length < 14
                ) {
                  sup = sup + "0";
                }
                return that.formSearch.produceBatch + sup + item;
              });
              that.searchParam.gasType = that.formSearch.gasType;
              that.searchParam.selectCondition = "batch";
              that.searchParam.meterList = meterList;
            } else if (that.formSearch.selectCondition == "address") {
              addressId = that.formSearch.addressDataSelect;
              that.searchParam.gasType = that.formSearch.gasType;
              that.searchParam.selectCondition = "address";
              that.searchParam.addressId = addressId;
            }
            that.current = 1;
            that.step[0] = false;
            that.step[1] = true;
            that.showPage();
          }
        });
      } else if (that.current == 1) {
        that.current = 2;
        that.step[1] = false;
        that.step[2] = true;
        that.isSpinShow = true;
        that.showLadderPage();
      } else if (that.current == 2) {
        if (that.selectedRow && that.meterIds) {
          that.showResult = true;
          that.isButtonShow = false;
          Object.keys(that.array).map((item) => {
            let inputData = {};
            inputData["deviceId"] = that.array[item].id;
            inputData["commandType"] = "0x12";
            inputData["command"] = {};
            inputData.command["paras"] = JSON.parse(
              that.selectedRow.ladderDataString
            );
            for (var i = 1; i <= 6; i++) {
              inputData.command["paras"]["mainPlanLadder" + i + "Price"] =
                inputData.command["paras"]["mainPlanLadder" + i + "Price"] >> 0;
              inputData.command["paras"]["standbyPlanLadder" + i + "Price"] =
                inputData.command["paras"]["standbyPlanLadder" + i + "Price"] >>
                0;
            }

            $.ajax({
              url: "/api/instructions/downInstructionData",
              contentType: "application/json",
              type: "post",
              data: JSON.stringify(inputData),
              dataType: "json",
              success: function(receiveData) {
                if (receiveData.errorCode == 0) {
                  that.array[item].state = "下发成功";
                } else {
                  that.array[item].state = receiveData.errorInfo;
                }
              },
              error: function(textStatus) {
                that.$Notice.error({
                  title: "异常",
                  desc: "接口请求异常",
                });
              },
            });
          });
        } else {
          if (!that.selectedRow) {
            that.$Notice.error({
              title: "异常",
              desc: "请选择一条数据",
            });
          } else if (!that.meterIds) {
            that.$Notice.error({
              title: "异常",
              desc: "无可下发设备",
            });
          }
        }
      }
    },
    request() {
      let that = this;
      that.isSpinShow = true;
      $.ajax({
        url: "/api/getAddressTree",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo,
            });
            return;
          }
          that.addressData = data.body[0].children;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常",
          });
        },
        complete: function() {
          that.isSpinShow = false;
        },
      });
    },
    showLadderPage() {
      let that = this;
      that.isSpinShow = true;
      that.selectedRow = null;
      $.ajax({
        url:
          "/api/ladderPrice/selectLadderPriceGasType?page=" +
          that.currentLadderPage +
          "&pageAmount=" +
          that.pageLadderSize,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({}),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo,
            });
            return;
          }
          that.showLadderData = data.body.resultList.map((param) => {
            param["ladderData"] = JSON.parse(param.ladderDataString) || {};
            let mainPlan = "";
            mainPlan +=
              "开始时间：" +
              global.dateFtt(
                "yyyy-MM-dd hh:mm:ss",
                new Date(param.ladderData.mainPlanStartTime)
              ) +
              "\n";
            mainPlan +=
              "结束时间：" +
              global.dateFtt(
                "yyyy-MM-dd hh:mm:ss",
                new Date(param.ladderData.mainPlanEndTime)
              ) +
              "\n";
            mainPlan +=
              "结算类型：" +
              global.ladderPriceSettleType[param.ladderData.mainPlanSettleType];
            if (
              param.ladderData.mainPlanSettleType != 0 &&
              param.ladderData.mainPlanSettleType != 4
            ) {
              mainPlan +=
                "\n结算周期：" + param.ladderData.mainPlanSettleParameter;
            }
            for (var i = 1; i <= 6; i++) {
              mainPlan +=
                "\n" +
                "第" +
                i +
                "阶梯共" +
                param.ladderData["mainPlanLadder" + i + "Flow"] +
                "m³,价格:" +
                param.ladderData["mainPlanLadder" + i + "Price"] / 100 +
                "元/m³";
            }
            param["mainPlan"] = mainPlan;
            let standbyPlan = "";
            standbyPlan +=
              "开始时间：" +
              global.dateFtt(
                "yyyy-MM-dd hh:mm:ss",
                new Date(param.ladderData.standbyPlanStartTime)
              ) +
              "\n";
            standbyPlan +=
              "结束时间：" +
              global.dateFtt(
                "yyyy-MM-dd hh:mm:ss",
                new Date(param.ladderData.standbyPlanEndTime)
              ) +
              "\n";
            standbyPlan +=
              "结算类型：" +
              global.ladderPriceSettleType[
                param.ladderData.standbyPlanSettleType
              ];
            if (
              param.ladderData.standbyPlanSettleType != 0 &&
              param.ladderData.standbyPlanSettleType != 4
            ) {
              standbyPlan +=
                "\n结算周期：" + param.ladderData.standbyPlanSettleParameter;
            }
            for (var i = 1; i <= 6; i++) {
              standbyPlan +=
                "\n" +
                "第" +
                i +
                "阶梯共" +
                param.ladderData["standbyPlanLadder" + i + "Flow"] +
                "m³,价格:" +
                param.ladderData["standbyPlanLadder" + i + "Price"] / 100 +
                "元/m³";
            }
            param["standbyPlan"] = standbyPlan;
            return param;
          });
          console.log(that.showLadderData);
          that.dataLadderCount = data.body.amount;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常",
          });
        },
        complete: function() {
          that.isSpinShow = false;
        },
      });
    },
    changeLadderPage(index) {
      this.currentLadderPage = index;
      this.showLadderPage();
    },
    changePageLadderSize(size) {
      this.pageLadderSize = size;
      this.showLadderPage();
    },
    onSelectionLadderTableChange(currentRow) {
      this.selectedRow = currentRow;
    },
  },
};
</script>

<style></style>
